interface Config {
  apiBaseUrl: string;
  timezone: string;
}

export const config: Config = {
  timezone: "UTC+8",
  ...window.appConfig,
};
